import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import * as RadixTabs from '@radix-ui/react-tabs';
import tabsStyles from './Tabs.styles.esm.js';
import { TabsContext } from './TabsContext.esm.js';
import { TabsList } from './TabsList.esm.js';
import { TabsTrigger } from './TabsTrigger.esm.js';
import { cn } from '../../utils/cn.esm.js';

const TabsComponent = React__default.forwardRef((props, ref) => {
    const { className, variant = "text", inverse = false, children, onValueChange, showIcon = false } = props, tabsProps = __rest(props, ["className", "variant", "inverse", "children", "onValueChange", "showIcon"]);
    const { root } = tabsStyles();
    const contextValue = {
        variant,
        inverse,
        onValueChange,
        showIcon,
    };
    return (jsx(TabsContext.Provider, { value: contextValue, children: jsx(RadixTabs.Root, Object.assign({ activationMode: "manual", ref: ref, className: cn(root({ class: className })) }, tabsProps, { children: children })) }));
});
// Set correct display names
TabsComponent.displayName = "Tabs";
// Create the main Tabs component with proper typing
const Tabs = TabsComponent;
// Attach the subcomponents
Tabs.List = TabsList;
Tabs.Trigger = TabsTrigger;
// Set proper display names for subcomponents
TabsList.displayName = "Tabs.List";
TabsTrigger.displayName = "Tabs.Trigger";

export { Tabs };
